import React from "react";
import type {
  OperationsApprovalTimeChartData,
  OperationsComplaintsChartData,
  OperationsOnHoldCanceledChartData,
  OperationsTotalRequestsTrendChartData,
} from "./types";
// Future: Frontdesk response time, Internal chat response time
import { OperationsApprovalTimeWidget } from "./widgets/OperationsApprovalTimeWidget";
import { OperationsComplaintsWidget } from "./widgets/OperationsComplaintsWidget";
import { OperationsOnHoldCanceledWidget } from "./widgets/OperationsOnHoldCanceledWidget";
import { OperationsTotalRequestsTrendWidget } from "./widgets/OperationsTotalRequestsTrendWidget";

interface OperationsMetricChartsSectionProps {
  totalRequestsTrendChart: OperationsTotalRequestsTrendChartData;
  totalRequestsTrendYMax: number;
  onHoldCanceledChart: OperationsOnHoldCanceledChartData;
  onHoldCanceledYMax: number;
  approvalTimeChart: OperationsApprovalTimeChartData;
  approvalTimeYMax: number;
  complaintsChart: OperationsComplaintsChartData;
  complaintsYMax: number;
  onExportTotalRequests?: (format: "csv" | "xlsx") => void;
  onExportOnHoldCanceled?: (format: "csv" | "xlsx") => void;
  onExportApprovalTime?: (format: "csv" | "xlsx") => void;
  onExportComplaints?: (format: "csv" | "xlsx") => void;
  exportDisabled?: boolean;
}

export const OperationsMetricChartsSection: React.FC<
  OperationsMetricChartsSectionProps
> = ({
  totalRequestsTrendChart,
  totalRequestsTrendYMax,
  onHoldCanceledChart,
  onHoldCanceledYMax,
  approvalTimeChart,
  approvalTimeYMax,
  complaintsChart,
  complaintsYMax,
  onExportTotalRequests,
  onExportOnHoldCanceled,
  onExportApprovalTime,
  onExportComplaints,
  exportDisabled = false,
}) => {
  return (
    <div className="flex w-full max-w-full flex-col gap-4">
      <OperationsTotalRequestsTrendWidget
        chart={totalRequestsTrendChart}
        yAxisMax={totalRequestsTrendYMax}
        onExport={onExportTotalRequests}
        exportDisabled={exportDisabled}
      />
      <OperationsOnHoldCanceledWidget
        chart={onHoldCanceledChart}
        yAxisMax={onHoldCanceledYMax}
        onExport={onExportOnHoldCanceled}
        exportDisabled={exportDisabled}
      />
      <OperationsApprovalTimeWidget
        chart={approvalTimeChart}
        yAxisMax={approvalTimeYMax}
        onExport={onExportApprovalTime}
        exportDisabled={exportDisabled}
      />
      <OperationsComplaintsWidget
        chart={complaintsChart}
        yAxisMax={complaintsYMax}
        onExport={onExportComplaints}
        exportDisabled={exportDisabled}
      />

      {/* Future: Frontdesk response time */}
      {/* Future: Internal chat response time */}
    </div>
  );
};
